import React, { Component } from 'react';
import Image from 'react-bootstrap/Image';
import Nav from 'react-bootstrap/Nav';
import { Link, withRouter } from 'react-router-dom';
import { FaHome, FaCube, FaChartLine, FaCog, FaCalendarDay, FaClipboardList, FaFileInvoiceDollar } from "react-icons/fa";
import '../App.css';
import C from '../lib/Config';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';

class Side extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentDateTime: Date().toLocaleString(),
      userDetail: {
        firstName: localStorage.getItem("firstName") || "",
        lastName: localStorage.getItem("lastName") || "",
        userRole: localStorage.getItem("userRoleDto") || "",
      },
      isAnalyticsDropdownVisible: false,
      isConfigDropdownVisible: false,
      hasRestrictedAccess: false,
      isHospitalAdmin: false,
      instituteList: []
    };
  }

  componentDidMount() {
    this.checkUserRole();
    this.fetchInstituteList();
    document.addEventListener('click', this.handleOutsideClick);
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.handleOutsideClick);
  }

  fetchInstituteList = async () => {
    try {
      const userId = localStorage.getItem('userId');
      console.log(`Fetching institutes for userId: ${userId}`);
      const response = await fetch(C.getUrl() + '/institute/getAllInstituteByUserId/' + userId);
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const text = await response.text();
      console.log(`Response text length: ${text ? text.length : 0}`);
      
      if (!text) {
        console.warn("Empty response from server - API returned no data");
        this.setState({ instituteList: [], hasRestrictedAccess: false });
        return;
      }
      
      try {
        const data = JSON.parse(text);
        console.log(`Parsed institutes count: ${data ? data.length : 0}`);
        
        const hasRestrictedInstitute = data.some(institute => 
          institute.instituteId === 22 || institute.instituteId === 30
        );

        this.setState({ 
          instituteList: data,
          hasRestrictedAccess: hasRestrictedInstitute
        });
      } catch (jsonError) {
        console.error("Failed to parse JSON response:", jsonError);
        this.setState({ instituteList: [], hasRestrictedAccess: false });
      }
    } catch (error) {
      console.error("Error fetching institute list:", error);
      this.setState({ instituteList: [], hasRestrictedAccess: false });
    }
  };

  checkUserRole() {
    const { userRole } = this.state.userDetail;
    if (userRole) {
      const parsedUserRole = JSON.parse(userRole);
      const roleName = parsedUserRole.roleName;
      if (roleName === 'Hospital Admin') {
        this.setState({ isHospitalAdmin: true });
      } else if (roleName !== 'Moderator') {
        const viewDrop = document.getElementById('viewDrop');
        if (viewDrop) viewDrop.style.display = "none";
      }
    }
  }

  handleOutsideClick = (e) => {
    if (!e.target.closest('.analytics-dropdown') && !e.target.closest('.config-dropdown')) {
      this.setState({
        isAnalyticsDropdownVisible: false,
        isConfigDropdownVisible: false
      });
    }
  };

  toggleAnalyticsDropdown = (e) => {
    e.stopPropagation();
    this.setState(prevState => ({
      isAnalyticsDropdownVisible: !prevState.isAnalyticsDropdownVisible,
      isConfigDropdownVisible: false
    }));
  };

  toggleConfigDropdown = (e) => {
    e.stopPropagation();
    this.setState(prevState => ({
      isConfigDropdownVisible: !prevState.isConfigDropdownVisible,
      isAnalyticsDropdownVisible: false
    }));
  };

  renderNavItem = (to, icon, label) => {
    return (
      <Nav.Item className="active mb-5">
        <OverlayTrigger
          placement="right"
          overlay={<Tooltip id={`tooltip-${label}`}>{label}</Tooltip>}
        >
          <Link to={to} className="nav-link py-2">
            <div className="d-flex justify-content-center">
              {icon}
            </div>
          </Link>
        </OverlayTrigger>
      </Nav.Item>
    );
  };

  renderAnalyticsSection() {
    const { isAnalyticsDropdownVisible, hasRestrictedAccess } = this.state;
    const analyticsIcon = <FaChartLine className="side-menu__icon" style={{ fontSize: '2.5rem' }} />;

    if (hasRestrictedAccess) {
      return (
        <Nav.Item
          className="active analytics-dropdown mb-5"
          style={{ position: "relative", cursor: "pointer" }}
        >
          <OverlayTrigger
            placement="right"
            overlay={<Tooltip id="tooltip-analytics">Analytics</Tooltip>}
          >
            <div 
              onClick={this.toggleAnalyticsDropdown}
              onMouseEnter={() => this.setState({ isAnalyticsDropdownVisible: true })}
              className="nav-link d-flex justify-content-center py-2"
            >
              {analyticsIcon}
            </div>
          </OverlayTrigger>
          
          <div
            className={`dropdown-menu ${isAnalyticsDropdownVisible ? 'show' : ''}`}
            style={{
              position: "absolute",
              left: "100%",
              top: "0",
              transform: "translateY(0)",
              zIndex: 1050,
              backgroundColor: "#ffffff",
              borderRadius: "5px",
              padding: "10px",
              boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
              display: isAnalyticsDropdownVisible ? "block" : "none"
            }}
            onMouseLeave={() => this.setState({ isAnalyticsDropdownVisible: false })}
          >
            <Link to="/Analytics" className="dropdown-item">Progression Report</Link>
            <Link to="/chemoPlan" className="dropdown-item">Chemo Plan Report</Link>
            <Link to="/chemoEntry" className="dropdown-item">Chemo Entry - Consultation List</Link>
            <Link to="/chemoAppointment" className="dropdown-item">Chemo Plan Appointment Date List</Link>
            <Link to="/planCompletion" className="dropdown-item">Treatment Plan Completion Status List</Link>
            <Link to="/ChemoPatientDashboard" className="dropdown-item">Patient Status Summary Report</Link>
          </div>
        </Nav.Item>
      );
    }

    return this.renderNavItem('/Analytics', analyticsIcon, 'Analytics');
  }

  render() {
    const { isConfigDropdownVisible, isHospitalAdmin } = this.state;
    const iconSize = '2.5rem'; // Consistent icon size for all icons

    return (
      <Nav 
        className="navbar-nav sidebar sidebar-dark accordion sidebarRadius" 
        id="sidebar-wrapper"
        style={{
          overflowY: 'auto',
          maxHeight: '100vh',
          position: 'fixed',
          top: 0,
          bottom: 0,
          width: '70px', // Narrower sidebar for icon-only display
          paddingTop: '0.5rem'
        }}
      >
        <Nav.Item className="active mb-5">
          <Link to="/Dashboard" className="nav-link">
            <div className="d-flex justify-content-center mt-2 pt-2 mb-2 pb-2">
              <Image src={`${process.env.PUBLIC_URL}/img/Icon2.png`} style={{ width: "70px" }} />
            </div>
          </Link>
        </Nav.Item>

        {/* Dashboard */}
        {this.renderNavItem(
          '/Dashboard',
          <FaHome className="side-menu__icon" style={{ fontSize: iconSize }} />,
          'Dashboard'
        )}
        
        {/* My Cases */}
        {this.renderNavItem(
          '/Case',
          <FaCube className="side-menu__icon" style={{ fontSize: iconSize }} />,
          'My Cases'
        )}

        {/* Analytics section */}
        {this.renderAnalyticsSection()}

        
        {/* {this.renderNavItem(
          '/day-care',
          <FaCalendarDay className="side-menu__icon" style={{ fontSize: iconSize }} />,
          'Day Care'
        )}

        
        {this.renderNavItem(
          '/tumor-board',
          <FaClipboardList className="side-menu__icon" style={{ fontSize: iconSize }} />,
          'Tumor Board'
        )} */}
        
        {/* Invoices */}
        {this.renderNavItem(
          '/invoices',
          <FaFileInvoiceDollar className="side-menu__icon" style={{ fontSize: iconSize }} />,
          'Invoices'
        )}

        {/* Configuration section */}
        <Nav.Item
          className="active config-dropdown mb-5"
          id="viewDrop"
          style={{ position: "relative", cursor: "pointer" }}
        >
          <OverlayTrigger
            placement="right"
            overlay={<Tooltip id="tooltip-config">Configuration</Tooltip>}
          >
            <div 
              onClick={this.toggleConfigDropdown}
              onMouseEnter={() => this.setState({ isConfigDropdownVisible: true })}
              className="nav-link d-flex justify-content-center py-2"
            >
              <FaCog className="side-menu__icon" style={{ fontSize: iconSize, color: 'white' }} />
            </div>
          </OverlayTrigger>
          
          <div
            className={`dropdown-menu ${isConfigDropdownVisible ? 'show' : ''}`}
            style={{
              position: "absolute",
              left: "100%",
              top: "0",
              transform: "translateY(0)",
              zIndex: 1050,
              backgroundColor: "#ffffff",
              borderRadius: "5px",
              padding: "10px",
              boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
              display: isConfigDropdownVisible ? "block" : "none"
            }}
            onMouseLeave={() => this.setState({ isConfigDropdownVisible: false })}
          >
            {!isHospitalAdmin && <Link to="/Approve" className="dropdown-item">Approved User</Link>}
            <Link to="/pending" className="dropdown-item">Pending User</Link>
            <Link to="/ProtocolMaster" className="dropdown-item">Protocol Master</Link>
            <Link to="/MedicineList" className="dropdown-item">Add Medicine List</Link>
            {!isHospitalAdmin && <Link to="/AdverseEffectsMaster" className="dropdown-item">Adverse Effects Master</Link>}
            {!isHospitalAdmin && <Link to="/MedicineMaster" className="dropdown-item">Medicine Master</Link>}
            {!isHospitalAdmin && <Link to="/LabTestParameterMaster" className="dropdown-item">Lab Test Parameter Master</Link>}
            {!isHospitalAdmin && <Link to="/ReportParamMappingMST" className="dropdown-item">Lab Test Parameter Mapping Master</Link>}
          </div>
        </Nav.Item>
      </Nav>
    );
  }
}

export default Side;